<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_i">To my grandmother …</a></p><a id="page_i">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?28ec8963